export default "__VITE_ASSET__ExXTynR7__"